// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","zGreen":"#BFD730","primary":"#492172","arrow":"_3lkb","outerInline":"_1Ukt","outer":"_3KZc","white":"_3r3W","inactive":"qnuB","disabled":"_1ugL","outerBoxed":"_3EgL","standard":"_1cQ1","invalid":"_3cY-","fullwidth":"D80f"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/Input/Input.scss
// module id = rign
// module chunks = 0